module.exports = __webpack_public_path__ + "assets/1d8b5849b251d095b26e5311d9a99e53.mp3";